import { ContentFieldType } from "../../../types/cms/contentField.type";
import { SINGLE_TOKEN_REGEX } from "../internal/constants";
import { resolvePath } from "../internal/resolvePath";
import { resolveConditionals } from "../internal/resolveConditionals";
import type { InterpolateParams, ColorItem } from "../types";

export function extractColors({
  structure,
  template,
}: InterpolateParams): ColorItem[] | undefined {
  const match = resolveConditionals({ template, structure }).match(SINGLE_TOKEN_REGEX);
  if (!match) return undefined;

  const [, path, type] = match;
  if (type !== ContentFieldType.COLORS) return undefined;

  const value = resolvePath(structure, path);
  if (!Array.isArray(value)) return undefined;

  return value as ColorItem[];
}
